import { SpanDirection } from "building-types/floors/floorComponentsTypes";
import type { FrameFloorAssemblyEntity } from "building-types/floors/frameFloorAssemblyTypes";
import type { SlabFloorAssemblyEntity } from "building-types/floors/slabFloorAssemblyTypes";
import type { Table } from "common/data/table";
import { default2x12Id } from "../elements/framing/defaultLumberComponents";
import { defaultFloorSheathingComponentId } from "./assemblyComponentDefaults";
import { defaultSlabComponentId } from "./assemblyComponentDefaults";

export const defaultFrameFloorAssemblyId = "DEFAULT-FRAME-FLOOR-ASSEMBLY";
export const defaultSlabFloorAssemblyId = "DEFAULT-SLAB-FLOOR-ASSEMBLY";
// Default Frame Floor Assembly Components
export const builtInFrameFloorAssemblies: Table<FrameFloorAssemblyEntity> = {
  [defaultFrameFloorAssemblyId]: {
    entityType: "FRAME_FLOOR_ASSEMBLY",
    id: defaultFrameFloorAssemblyId,
    name: "Standard Wood Frame Assembly",
    joistComponentId: default2x12Id,
    subFloorComponentId: defaultFloorSheathingComponentId,
    rimComponentId: default2x12Id,
    tag: '2x12 @ 16" O.C.',
    joistSpacing: 16,
    spanDirection: SpanDirection.SHORTEST_SPAN,
    sortIndex: 0,
  },
};

export const builtInSlabFloorAssemblies: Table<SlabFloorAssemblyEntity> = {
  [defaultSlabFloorAssemblyId]: {
    entityType: "SLAB_FLOOR_ASSEMBLY",
    id: defaultSlabFloorAssemblyId,
    name: "Standard Concrete Slab Assembly",
    slabComponentId: defaultSlabComponentId,
    subFloorComponentId: defaultFloorSheathingComponentId,
    sortIndex: 0,
  },
};

// Built-in check functions
export function isBuiltInFrameFloorAssembly(id: string): boolean {
  return Object.keys(builtInFrameFloorAssemblies).includes(id);
}

export function isBuiltInSlabFloorAssembly(id: string): boolean {
  return Object.keys(builtInSlabFloorAssemblies).includes(id);
}

export const builtInFrameFloorAssembliesGroupId = "builtInFrameFloorAssembliesGroup";
export const builtInSlabFloorAssembliesGroupId = "builtInSlabFloorAssembliesGroup";
